import Swiper, { Navigation, Scrollbar } from "swiper";

Swiper.use([Navigation, Scrollbar]);

/**
 * Helper class to init multiple swiper instances
 */
export default class SliderInstance {
    constructor(selector, options) {
        /**
         * DOM Selectors
         * @type {{navigationPrev: string, navigationNext: string}}
         */
        this.DOM = {
            navigationNext: ".js-slider-instance-next",
            navigationPrev: ".js-slider-instance-prev",
            scrollBar: ".js-slider-instance-scrollbar",
        };

        /**
         * Parameters
         * @type {{selector: string, options: object }}
         */
        this.selector = selector;
        this.options = options;

        /**
         * Call init method
         */
        this.init(this.selector, this.options);
    }

    /**
     * Init Swiper
     * Merge default options with instance options
     */
    init(selector, options) {
        const defaults = {
            navigation: {
                nextEl: selector.parentNode.querySelector(
                    this.DOM.navigationNext,
                ),
                prevEl: selector.parentNode.querySelector(
                    this.DOM.navigationPrev,
                ),
            },
            scrollbar: {
                el: selector.parentNode.querySelector(this.DOM.scrollBar),
                hide: false,
                draggable: true,
            },
        };
        const mergedOptions = { ...defaults, ...options };
        new Swiper(selector, mergedOptions);
    }
}
